import React from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    FormControlLabel,
    Grid,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import FormContainer from '../../../components/Form/FormContainer/FormContainer';
import DatacorLogoSpinner from '../../../components/DatacorLogoSpinner/DatacorLogoSpinner';
import FixedAssetsFormHeader from '../../../components/Form/FormContainer/FormHeader';
import FormPartial from '../../../components/Form/FormContainer/FormPartial';
import TextInput from '../../../components/Form/FormInputs/TextInput/TextInput';
import NumericInput from '../../../components/Form/FormInputs/NumericInput/NumericInput';
import useFixedAssetDepreciationMethodStatusForm from '../hooks/useFixedAssetDepreciationMethodStatusForm';
import ToastContainer from '../../../components/Toast/ToastContainer';

interface ParamTypes {
    statusId: string;
}

const FixedAssetDepreciationMethodStatusForm = () => {
    const { statusId } = useParams<ParamTypes>();
    const {
        fields,
        handleFieldChange,
        formMethods,
        toastProps,
        onCreate,
        onUpdate,
        onDelete,
        closeForm,
        isLoadingStatus,
    } = useFixedAssetDepreciationMethodStatusForm(statusId);

    return (
        <Card>
            <CardHeader title="Fixed Asset Depreciation Method Status" />

            {isLoadingStatus ? (
                <DatacorLogoSpinner />
            ) : (
                <CardContent>
                    <ToastContainer {...toastProps} show={!!toastProps?.show} />

                    <FormContainer
                        headerTitle={'Primary Information'}
                        onSubmit={() => formMethods.setIsFormSubmitted(true)}
                        headerComponent={
                            <FixedAssetsFormHeader
                                showOnDelete={!!statusId}
                                showOnSave={true}
                                onSave={() => {
                                    if (!statusId) {
                                        onCreate();
                                    } else {
                                        onUpdate();
                                    }
                                }}
                                onDelete={() => {
                                    onDelete();
                                }}
                                onCancel={closeForm}
                                isEdit={!!statusId}
                            />
                        }>
                        <FormPartial>
                            <Grid container flexDirection="row" spacing={2}>
                                <Grid item xs={6}>
                                    <TextInput
                                        fullWidth
                                        label="Code"
                                        id="code"
                                        value={fields.code}
                                        onChange={handleFieldChange}
                                        formMethods={formMethods}
                                        required={true}
                                        maxLength={30}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <NumericInput
                                        fullWidth
                                        label="Sort Order"
                                        id="sortOrder"
                                        value={fields.sortOrder}
                                        onChange={handleFieldChange}
                                        formMethods={formMethods}
                                        required={true}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControlLabel
                                        label="Active"
                                        control={
                                            <Checkbox
                                                id="isActive"
                                                checked={fields.isActive}
                                                onChange={handleFieldChange}
                                            />
                                        }
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextInput
                                        fullWidth
                                        label="Description"
                                        id="description"
                                        value={fields.description}
                                        onChange={handleFieldChange}
                                        formMethods={formMethods}
                                        maxLength={300}
                                    />
                                </Grid>
                            </Grid>
                        </FormPartial>
                    </FormContainer>
                </CardContent>
            )}
        </Card>
    );
};

export default FixedAssetDepreciationMethodStatusForm;
